export default __webpack_public_path__ + "static/manor-house-3f973d8bd5ffc79fb517253fe88e36e6.svg";